<template>
  <div id="generate-document">
    <GlobalLoading v-if="$store.state.globalLoading" />
    <div class="document-container">
      <div
        ref="document"
        class="document-wrapper"
        style="padding: 0 !important"
      >
        <div
          style="width:100%;height:100%;display:flex;flex-direction:row;align-items:center; justify-content:center"
        >
          <div class="k3l-document-container">
            <!-- <Loading v-if="$store.state.globalLoading" /> -->
            <div class="k3l-document-dialog">
              <div class="k3l-document-content">
                <div class="k3l-document-body">
                  <!-- Table Detail Penilaian -->
                  <Table-Detail />
                  <!-- Kategory Penilaian -->
                  <div
                    style="padding-bottom:1%;padding-right:1%;border-right:1px solid gray;border-bottom:1px solid gray; margin-bottom:16px"
                  >
                    <div class="flex-row" style="background-color:#CCFFB3">
                      <div
                        class="text-sm text-bold text-center border column20"
                        style="padding:5px"
                      >
                        TINGKAT RESIKO PEKERJAAN
                      </div>
                      <div
                        class="text-sm text-bold text-center border column20"
                        style="padding:5px"
                      >
                        NILAI
                      </div>
                      <div
                        class="text-sm text-bold text-center border column60 col-nohover"
                        style="padding:5px"
                      >
                        KETERANGAN
                      </div>
                    </div>
                    <div
                      class="flex-row"
                      v-for="(item, index) in tableDesc"
                      :key="index"
                    >
                      <div
                        :class="`${item.styling1} border flex-center`"
                        :style="`height: auto; background-color: ${item.color}`"
                      >
                        {{ item.desc1 }}
                      </div>
                      <div
                        :class="`${item.styling2} border`"
                        style="height: auto"
                        v-html="item.desc2"
                      ></div>
                      <div
                        :class="`${item.styling3} border`"
                        style="height: auto"
                        v-html="item.desc3"
                      ></div>
                    </div>
                  </div>
                  <!-- Table Evaluasi -->
                  <div class="flex-row " style="position:relative">
                    <div
                      class="column25 flex-row"
                      style="position: absolute;top:-15px; height: auto;"
                    >
                      <div class="text-ssm mr5">Jenis Penilaian :</div>
                      <div>
                        <div
                          class="flex-row"
                          style="height:0.75rem; margin-bottom:2px"
                        >
                          <div class="border-check text-ssm flex-center mr5">
                            &#128504;
                          </div>
                          <div class="text-ssm">
                            PQ1 - Dokumen
                          </div>
                        </div>
                        <div class="flex-row" style="height:0.75rem">
                          <div class="border-check text-ssm flex-center mr5">
                            -
                          </div>
                          <div class="text-ssm">
                            PQ2 - Audit Lapangan
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="column25" style="background-color: transparent">
                      &nbsp;
                    </div>
                    <div
                      class="column25 border-gray text-center text-bold"
                      style="background-color: #66FF66"
                    >
                      NAMA
                    </div>
                    <div
                      class="column25 border-gray text-center text-bold"
                      style="background-color: #66FF66"
                    >
                      POSISI
                    </div>
                    <div
                      class="column25 border-gray text-center text-bold"
                      style="background-color: #66FF66"
                    >
                      TANDATANGAN
                    </div>
                  </div>
                  <div class="flex-row">
                    <div class="column25 flex-row border-gray flex-center" style="height: auto;">
                      Dievaluasi Oleh
                    </div>
                    <div class="column25 border-gray text-center" style="height: auto;">
                      {{ user }}
                    </div>
                    <div class="column25 border-gray text-center all-column" style="height: auto;">
                      {{ position }}
                    </div>
                    <div class="column25 border-gray text-center" style="height: auto;">
                      {{ user ? 'Approved' : '-' }}
                    </div>
                  </div>
                  <div class="flex-row">
                    <div class="column25 flex-row border-gray flex-center" style="height: auto;">
                      Ditinjau ulang Oleh
                    </div>
                    <div class="column25 border-gray flex-center" style="height: auto;">
                      {{ hoc ? hoc : '-' }}
                    </div>
                    <div class="column25 border-gray text-center col-nohover" style="height: auto;">
                      {{ position_hoc ? position_hoc : '-' }}
                    </div>
                    <div class="column25 border-gray flex-center" style="height: auto;">
                      {{ hoc ? 'Approved' : '-' }}
                    </div>
                  </div>
                  <div class="flex-row">
                    <div class="column25 flex-row border-gray flex-center" style="height: auto;">
                      Diketahui Oleh
                    </div>
                    <div class="column25 text-center border-gray" style="height: auto;">
                      SIPM Specialist
                    </div>
                    <div class="column25 text-center border-gray" style="height: auto;">
                      SIPM Specialist
                    </div>
                    <div class="column25 text-center border-gray" style="height: auto;">Approved</div>
                  </div>
                  <div class="mt10 text-sm">
                    Hasil penilaian prakualifikasi K3L ini berlaku di PT Berau
                    Coal dan tidak valid jika hasil penilaian baru telah keluar
                    atau bila terjadi kecelakaan fatality atau Lost Time
                    Insident (LTI) di kontraktor saat bekerja untuk PT Berau
                    Coal.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button class="floating-button" @click="exportToPDF">Export to PDF</button>
    <button class="top-floating-button" @click="exportToPDF">
      Export to PDF
    </button>
  </div>
</template>

<script>
import VueJwtDecode from 'vue-jwt-decode'
import html2pdf from 'html2pdf.js'
import axios from 'axios'
import { api, api_lp } from '../../services/config'
export default {
  components: {
    GlobalLoading: () => import('../../components/V2/GlobalLoading.vue'),
    TableDetail: () =>
      import('../../components/molecules/tableDetailPenilaian.vue'),
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
      user: '',
      position: '',
      hoc: '',
      position_hoc: '',
      tableDesc: [
        {
          color: '#FF0000',
          desc1: 'HIGH A',
          desc2: '>80 - 100',
          desc3:
            'Pengadaan Jasa / Barang dengan kategori pekerjaan di area Operasi Tambang, membutuhkan sertifikasi keahlian umum hingga khusus, membutuhkan dokumen IUJP/SIUP, Rencana K3L & Pekerjaan kritis >4 aktifitas.',
          styling1: 'text-sm text-bold column20',
          styling2: 'text-sm column20',
          styling3: 'text-sm column60 col-nohover',
        },
        {
          color: '#FFC000',
          desc1: 'MEDIUM B1',
          desc2: '>50 - &#8804;80',
          desc3:
            'Pengadaan Jasa / Barang dengan kategori pekerjaan di area Operasi Tambang, membutuhkan sertifikasi keahlian umum hingga khusus, membutuhkan dokumen IUJP/SIUP, Rencana K3L & Pekerjaan kritis 2&#8805; - &#8804;4 aktifitas.',
          styling1: 'text-sm text-bold column20',
          styling2: 'text-sm column20',
          styling3: 'text-sm column60 col-nohover',
        },
        {
          color: '#FFFF00',
          desc1: 'MEDIUM - B2',
          desc2: '>35 - &#8804;50',
          desc3:
            'Pengadaan Jasa / Barang dengan kategori pekerjaan di area Operasi Non Tambang, membutuhkan sertifikasi keahlian umum hingga khusus, membutuhkan dokumen SIUP & Pekerjaan kritis &#8804;2 aktifitas.',
          styling1: 'text-sm text-bold column20',
          styling2: 'text-sm column20',
          styling3: 'text-sm column60 col-nohover',
        },
        {
          color: '#00B050',
          desc1: 'LOW - C1',
          desc2: '>20 - &#8804;35',
          desc3:
            'Pengadaan Jasa dengan kategori pekerjaan di area Operasi Non Tambang, membutuhkan sertifikasi keahlian umum hingga khusus, membutuhkan dokumen SIUP.',
          styling1: 'text-sm text-bold column20',
          styling2: 'text-sm column20',
          styling3: 'text-sm column60 col-nohover',
        },
        {
          color: '#92D050',
          desc1: 'LOW - C2',
          desc2: '0 - &#8804;20',
          desc3:
            'Pengadaan Barang dengan kategori pekerjaan di area Operasi Non Tambang, membutuhkan sertifikasi keahlian umum hingga khusus, membutuhkan dokumen SIUP.',
          styling1: 'text-sm text-bold column20',
          styling2: 'text-sm column20',
          styling3: 'text-sm column60 col-nohover',
        },
      ],
    }
  },
  async created() {
    const token = await this.$route.params.token
    const dec = await VueJwtDecode.decode(token)
    const { id } = dec
    await this.getK3LPenilaian(id)
  },
  methods: {
    async exportToPDF() {
      this.isVisible = true
      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
      await html2pdf(this.$refs.document, {
        margin: [0.1, 0.1],
        filename: `K3L-Penilaian-${this.$route.params.vendor}.pdf`,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 4, dpi: 192, letterRendering: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
      })
      this.isVisible = false
      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
    },
    async getK3LPenilaian(id) {
      const url = `${api_lp}/api/v1/vendor/k3l-penilaian/${id}`

      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          console.log(
            '🚀 ~ file: ValidationK3L.vue ~ line 306 ~ .then ~ data',
            data
          )

          this.user = data.data.user
          this.position = data.data.position
          this.hoc = data.data.hoc
          this.position_hoc = data.data.position_hoc
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 469 ~ getParent ~ error',
            error
          )
        })
    },
  },
}
</script>
